import "core-js/modules/es6.array.map";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/**
 * TODO: Add in filter
 */


import * as React from 'react';
import { List } from './components/List';
import styled from 'styled-components';
import { DROPDOWN_PADDING } from '..';
import keyCodes from '../../../../constants/keycodes';
import getDocument from '../../../../utilities/get-document';
var HANDLED_KEYCODES = [keyCodes.ENTER, keyCodes.UP, keyCodes.DOWN];
var document = getDocument();

var DropdownList =
/** @class */
function (_super) {
  __extends(DropdownList, _super);

  function DropdownList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      currentIndex: -1
    };

    _this.handleKeyDown = function (e) {
      var _a = _this.props,
          onSelectItem = _a.onSelectItem,
          selectedIndex = _a.selectedIndex;

      if (!HANDLED_KEYCODES.includes(e.key)) {
        return;
      }

      var currentIndex = _this.state.currentIndex;
      var index = _this.state.currentIndex;
      var startingIndex;
      var itemsLength = _this.props.items.length;

      switch (e.key) {
        case keyCodes.ENTER:
          if (currentIndex > -1) {
            e.preventDefault();
            var item = _this.props.items[currentIndex];

            if (item && onSelectItem) {
              onSelectItem(item, currentIndex, e);
            }

            _this.setState({
              currentIndex: -1
            });
          }

          break;

        case keyCodes.UP:
          e.preventDefault();

          var prevIndex = function prevIndex(i) {
            return i - 1 < 0 ? itemsLength - 1 : i - 1;
          };

          index = prevIndex(index);
          startingIndex = currentIndex > -1 ? currentIndex : index;

          while (index === selectedIndex || _this.items[index].disabled) {
            index = prevIndex(index);

            if (index === startingIndex) {
              index = currentIndex;
              break;
            }
          }

          _this.setState({
            currentIndex: index
          });

          break;

        case keyCodes.DOWN:
          e.preventDefault();

          var nextIndex = function nextIndex(i) {
            return i + 1 > itemsLength - 1 ? 0 : i + 1;
          };

          index = nextIndex(currentIndex);
          startingIndex = currentIndex > -1 ? currentIndex : index;

          while (index === selectedIndex || _this.items[index].disabled) {
            index = nextIndex(index);

            if (index === startingIndex) {
              index = currentIndex;
              break;
            }
          }

          _this.setState({
            currentIndex: index
          });

          break;
      }
    };

    return _this;
  }

  DropdownList.prototype.componentDidMount = function () {
    if (this.props.keyboardNav) {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  };

  DropdownList.prototype.componentWillUnmount = function () {
    if (this.props.keyboardNav) {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  };

  Object.defineProperty(DropdownList.prototype, "items", {
    get: function get() {
      var _this = this;

      return this.props.items.map(function (item, i) {
        return i === _this.state.currentIndex ? __assign(__assign({}, item), {
          isHighlighted: true
        }) : item;
      });
    },
    enumerable: true,
    configurable: true
  });

  DropdownList.prototype.render = function () {
    var _a = this.props,
        emptyState = _a.emptyState,
        hideLines = _a.hideLines,
        maxHeight = _a.maxHeight,
        itemRenderer = _a.itemRenderer,
        noWrap = _a.noWrap,
        onSelectItem = _a.onSelectItem,
        selectedIndex = _a.selectedIndex;
    return React.createElement(ListContainer, {
      maxHeight: maxHeight,
      noWrap: noWrap
    }, React.createElement(List, {
      emptyState: emptyState,
      hideLines: hideLines,
      itemRenderer: itemRenderer,
      items: this.items,
      onSelectItem: onSelectItem,
      selectedIndex: selectedIndex
    }));
  };

  DropdownList.defaultProps = {
    keyboardNav: true
  };
  return DropdownList;
}(React.Component);

export { DropdownList };
var ListContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow-y: ", ";\n    white-space: ", ";\n\n    margin: ", ";\n    max-height: ", ";\n"], ["\n    overflow-y: ", ";\n    white-space: ", ";\n\n    margin: ", ";\n    max-height: ", ";\n"])), function (props) {
  return props.maxHeight ? 'auto' : 'visible';
}, function (props) {
  return props.noWrap ? 'nowrap' : 'normal';
}, function (props) {
  return props.theme.units.getValue(-DROPDOWN_PADDING);
}, function (props) {
  return typeof props.maxHeight === 'number' ? props.theme.units.getValue(props.maxHeight) : props.maxHeight;
});
var templateObject_1;